import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { RefDataProvider } from "@/context/RefDataContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import BizProjects from "@/pages/BizProjects";
import BizProjectDetail from "@/pages/BizProjectDetail";
import Assets from "@/pages/Assets";
import AssetDetail from "@/pages/AssetDetail";
import Services from "@/pages/Services";
import Tasks from "@/pages/Tasks";
import TaskDetail from "@/pages/TaskDetail";
import Issues from "@/pages/Issues";
import IssueDetail from "@/pages/IssueDetail";
import Teams from "@/pages/Teams";
import TeamDetail from "@/pages/TeamDetail";
import Users from "@/pages/Users";
import UserDetail from "@/pages/UserDetail";
import Wallets from "@/pages/Wallets";
import WalletDetail from "@/pages/WalletDetail";
import MyWallet from "@/pages/MyWallet";
import TeamWallets from "@/pages/TeamWallets";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import TeamsUsers from "@/pages/TeamsUsers";
import Assignments from "@/pages/Assignments";
import OPAHandle from "@/pages/OPAHandle";
import OPADetail from "@/pages/OPADetail";
import Approvals from "@/pages/Approvals";

function Shell({ children }) {
  return (
    <RefDataProvider>
      <AppLayout>{children}</AppLayout>
    </RefDataProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/" element={<ProtectedRoute><Shell><Dashboard /></Shell></ProtectedRoute>} />
            <Route path="/projects" element={<ProtectedRoute><Shell><Projects /></Shell></ProtectedRoute>} />
            <Route path="/projects/:id" element={<ProtectedRoute><Shell><ProjectDetail /></Shell></ProtectedRoute>} />
            <Route path="/biz-projects" element={<ProtectedRoute><Shell><BizProjects /></Shell></ProtectedRoute>} />
            <Route path="/biz-projects/:id" element={<ProtectedRoute><Shell><BizProjectDetail /></Shell></ProtectedRoute>} />
            <Route path="/assets" element={<ProtectedRoute><Shell><Assets /></Shell></ProtectedRoute>} />
            <Route path="/assets/:id" element={<ProtectedRoute><Shell><AssetDetail /></Shell></ProtectedRoute>} />
            <Route path="/services" element={<ProtectedRoute><Shell><Services /></Shell></ProtectedRoute>} />
            <Route path="/tasks" element={<ProtectedRoute><Shell><Tasks /></Shell></ProtectedRoute>} />
            <Route path="/tasks/:id" element={<ProtectedRoute><Shell><TaskDetail /></Shell></ProtectedRoute>} />
            <Route path="/issues" element={<ProtectedRoute><Shell><Issues /></Shell></ProtectedRoute>} />
            <Route path="/issues/:id" element={<ProtectedRoute><Shell><IssueDetail /></Shell></ProtectedRoute>} />
            <Route path="/opa" element={<ProtectedRoute><Shell><OPAHandle /></Shell></ProtectedRoute>} />
            <Route path="/opa/:id" element={<ProtectedRoute><Shell><OPADetail /></Shell></ProtectedRoute>} />
            <Route path="/approvals" element={<ProtectedRoute><Shell><Approvals /></Shell></ProtectedRoute>} />
            <Route path="/teams" element={<ProtectedRoute><Shell><Teams /></Shell></ProtectedRoute>} />
            <Route path="/teams/:id" element={<ProtectedRoute><Shell><TeamDetail /></Shell></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><Shell><Users /></Shell></ProtectedRoute>} />
            <Route path="/users/:id" element={<ProtectedRoute><Shell><UserDetail /></Shell></ProtectedRoute>} />
            <Route path="/wallets" element={<ProtectedRoute><Shell><Wallets /></Shell></ProtectedRoute>} />
            <Route path="/wallets/:id" element={<ProtectedRoute><Shell><WalletDetail /></Shell></ProtectedRoute>} />
            <Route path="/my-wallet" element={<ProtectedRoute><Shell><MyWallet /></Shell></ProtectedRoute>} />
            <Route path="/team-wallets" element={<Navigate to="/my-wallet?tab=team" replace />} />
            <Route path="/settings" element={<ProtectedRoute><Shell><Settings /></Shell></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Shell><Profile /></Shell></ProtectedRoute>} />
            <Route path="/teams-users" element={<ProtectedRoute><Shell><TeamsUsers /></Shell></ProtectedRoute>} />
            <Route path="/assignments" element={<ProtectedRoute><Shell><Assignments /></Shell></ProtectedRoute>} />
            <Route path="/my" element={<ProtectedRoute><Shell><Assignments /></Shell></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><Shell><Assignments /></Shell></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
